import { AlertNotification, Button } from "@commonsku/styles";
import React from "react";

interface ShopifyMissingVariantOrSkuBarProps {
  itemId: string;
  onEditItem: (itemId: string) => void;
}

const ShopifyMissingVariantOrSkuBar = ({
  itemId,
  onEditItem,
}: ShopifyMissingVariantOrSkuBarProps) => {
  const handleAddVariants = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onEditItem(itemId);
  };
  return (
    <>
      <AlertNotification
        alertType={"warn"}
        style={{
          height: 44,
          alignItems: "center",
          marginTop: 8,
          marginBottom: 8,
          fontSize: 16,
        }}
      >
        Missing Variant(s) / SKU(s)
        <Button
          size="tiny"
          variant="primary"
          style={{ marginLeft: "auto" }}
          onClick={handleAddVariants}
        >
          Add Variants
        </Button>
      </AlertNotification>
    </>
  );
};

export default ShopifyMissingVariantOrSkuBar;
